import { validarEmail, formatRut, isValidRut } from '../../../utils/index';

const valoresFormularioLaboral = (
    valor,
    indice,
    datosPersonales,
    setDatosPersonales,
    datosLaborales,
    setDatosLaborales,
    antiguedadTrabajandoDependiente,
    checkDataDatosPersonales,
    setCheckDataDatosPersonales,
    overDatosPersonales
    ) => {
    const { formularioTrabajadorDependiente } = datosLaborales;
    const { formularioDatosPersonales } = datosPersonales;
   
    if (indice === 'tipoDeCargo') {
      formularioTrabajadorDependiente[0].cargo = valor.descripcion;
      setDatosLaborales({ ...datosLaborales, formularioTrabajadorDependiente });
    }

    if (indice === 'contratoActual') {
      const { antiguedadTrabajador, contratoSeleccionadoInicial } = datosLaborales;
      if (valor === 10) {
        antiguedadTrabajador.codigo = '';
        antiguedadTrabajador.descripcion = 'Seleciona';
        formularioTrabajadorDependiente[0].tiempoTrabajando = '';
        setDatosLaborales({
          ...datosLaborales,
          formularioTrabajadorDependiente,
          antiguedadTrabajador,
        });
      } else {
        formularioTrabajadorDependiente[0].tiempoTrabajando = valor.codigo;
        
        if (formularioTrabajadorDependiente[0].rutDependienteInicial !== '') {
          formularioTrabajadorDependiente[0].rutDependiente = formularioTrabajadorDependiente[0].rutDependienteInicial;
        }

        const filtro = antiguedadTrabajandoDependiente.filter(function (e) {
          return e.value === valor;
        });

        if (formularioTrabajadorDependiente[0].contratoInicial !== '' && filtro.length === 0) {
          contratoSeleccionadoInicial.codigo = parseInt(contratoSeleccionadoInicial.codigo, 10);
          formularioTrabajadorDependiente[0].contrato = formularioTrabajadorDependiente[0].contratoInicial;
          setDatosLaborales({
            ...datosLaborales,
            contratoSeleccionado: contratoSeleccionadoInicial,
            formularioTrabajadorDependiente
          });
        } else if (formularioTrabajadorDependiente[0].contratoInicial !== '' && filtro.length > 0) {
          setDatosLaborales({
            ...datosLaborales,
            contratoSeleccionado: contratoSeleccionadoInicial,
            formularioTrabajadorDependiente,
            antiguedadTrabajador: { codigo: filtro[0].value.toString(), descripcion: filtro[0].text },
          });
        } else if (filtro.length > 0) {
          setDatosLaborales({
            ...datosLaborales,
            formularioTrabajadorDependiente,
            antiguedadTrabajador: { codigo: filtro[0].value.toString(), descripcion: filtro[0].text },
          });
        } else {
          setDatosLaborales({
            ...datosLaborales,
            formularioTrabajadorDependiente
          });
        }
      }
    }
    if (indice === 'cuantosGanas') {
      if (valor === '') {
        setDatosLaborales({
          ...datosLaborales,
          formularioTrabajadorDependiente,
          textoAsistidoCuantoGana: [{ type: 'assist', text: 'Ingresa la cifra exacta, sin redondear' }],
        });
      } else {
        const removerDolar = valor.replaceAll('$', '');
        const removerDo = removerDolar.replaceAll('.', '');
        if (/^([0-9])*$/.test(removerDo)) {
          const monto = removerDo;
          if (monto <= 100000) {
            formularioTrabajadorDependiente[0].cuantoGanaAlMes = removerDolar;
            setDatosLaborales({
              ...datosLaborales,
              formularioTrabajadorDependiente,
              textoAsistidoCuantoGana: [
                { type: 'error', text: 'Monto ingresado debe ser mayor a $100.000' },
              ],
            });
          } else {
            formularioTrabajadorDependiente[0].cuantoGanaAlMes = removerDolar;
            setDatosLaborales({
              ...datosLaborales,
              formularioTrabajadorDependiente,
              textoAsistidoCuantoGana: [
                { type: 'assist', text: 'Ingresa la cifra exacta, sin redondear' },
              ],
            });
          }
        } else {
          formularioTrabajadorDependiente[0].cuantoGanaAlMes = '';
          setDatosLaborales({
            ...datosLaborales,
            formularioTrabajadorDependiente,
            textoAsistidoCuantoGana: [{ type: 'error', text: 'Caracter incorrecto' }],
          });
        }
      }
    }

    if (indice === 'rutEmpleador') {
      const { textoAsistidoRut } = datosLaborales;
      textoAsistidoRut[0].type = '';
      textoAsistidoRut[0].text = '';
      if (valor === '' || valor === 0) {
        formularioTrabajadorDependiente[0].rutDependiente = '';
      } else if (isValidRut(valor.toString())) {
        formularioTrabajadorDependiente[0].rutDependiente = formatRut(valor);
        setDatosLaborales({ ...datosLaborales, formularioTrabajadorDependiente });
      } else {
        textoAsistidoRut[0].type = 'error';
        textoAsistidoRut[0].text = 'Rut ingresado es incorrecto';
        formularioTrabajadorDependiente[0].rutDependiente = formatRut(valor);
        setDatosLaborales({ ...datosLaborales, formularioTrabajadorDependiente });
      }
    }

    /** Ambos Campos activan Datos Laborales */

    if (indice === 'email') {
      const { textoAsistidoEmail } = datosPersonales;

      if (valor === undefined || valor === '' || valor === null) {
        textoAsistidoEmail[0].type = 'assist';
        textoAsistidoEmail[0].text = 'Aquí recibirás tu comprobante';
        formularioDatosPersonales[0].email = '';
        setDatosPersonales({ ...datosPersonales, textoAsistidoEmail });
      } else {
        const emailValidar = validarEmail(valor);

        if (emailValidar) {
          textoAsistidoEmail[0].type = 'assist';
          textoAsistidoEmail[0].text = 'Aquí recibirás tu comprobante';
          formularioDatosPersonales[0].email = valor;
          formularioDatosPersonales[0].estadoEmail = 1;
          setCheckDataDatosPersonales({ ...checkDataDatosPersonales, estadoInfo: true });
          setDatosPersonales({ ...datosPersonales, textoAsistidoEmail, formularioDatosPersonales });
          overDatosPersonales();
        } else {
          // const { textoAsistidoEmail } = datosPersonales;
          textoAsistidoEmail[0].type = 'error';
          textoAsistidoEmail[0].text = 'Email no valido';
          formularioDatosPersonales[0].estadoEmail = 0;
          formularioDatosPersonales[0].email = valor;
          setCheckDataDatosPersonales({ ...checkDataDatosPersonales, estadoInfo: false });
          setDatosPersonales({
            ...datosPersonales,
            textoAsistidoEmail,
            formularioDatosPersonales,
          });
          overDatosPersonales();
        }
      }
    }

    if (indice === 'telefono') {
      formularioDatosPersonales[0].numeroDeCelular = valor;
      setDatosPersonales({ ...datosPersonales, formularioDatosPersonales });
      if (valor.length >= 9) {
        formularioDatosPersonales[0].estadoNumeroDeCelular = 1;
        setCheckDataDatosPersonales({ ...checkDataDatosPersonales, estadoInfo: true });
        setDatosPersonales({ ...datosPersonales, formularioDatosPersonales });
        overDatosPersonales();
        // Activa el card DatosLaborales
      } else {
        formularioDatosPersonales[0].estadoNumeroDeCelular = 0;
        setCheckDataDatosPersonales({ ...checkDataDatosPersonales, estadoInfo: false });
        setDatosPersonales({ ...datosPersonales, formularioDatosPersonales });
        overDatosPersonales();
      }
    }

    /** Ambos Campos activan Datos Laborales */

    if (indice === 'nombreUsuario') {
      formularioDatosPersonales[0].nombreCompleto = valor;
      setDatosPersonales({ ...datosPersonales, formularioDatosPersonales });
    }

    if (indice === 'pais') {
      // const { pais } = data;

      formularioDatosPersonales[0].pais = valor === 'CL' ? valor : '';

      setDatosPersonales({ ...datosPersonales, formularioDatosPersonales });
      overDatosPersonales();
    }
};

export default valoresFormularioLaboral;